
export const features = [
  {
    icon: "IdCard",
    title: "Unique Pet Identity & SSN",
    description: "🆔 Assign your pet a unique Pet Social Security Number (Pet SSN) that serves as their permanent digital identity for life. Instantly verify ownership and streamline all pet-related interactions.",
    color: "bg-pet-purple",
    gradient: "from-purple-300 to-indigo-400"
  },
  {
    icon: "Shield",
    title: "Identity Verification",
    description: "Prove pet ownership instantly with their Pet SSN. Perfect for vet visits, boarding facilities, travel, and emergency situations where quick verification is critical.",
    color: "bg-pet-blue",
    gradient: "from-blue-300 to-cyan-400"
  },
  {
    icon: "FileText",
    title: "Secure Document Vault",
    description: "Never lose important papers again! Store vaccination records, medical history, and certificates securely linked to your pet's digital identity. Access instantly during vet visits, for insurance claims, or emergencies - saving you time and stress when it matters most.",
    color: "bg-pet-green",
    gradient: "from-emerald-300 to-teal-400"
  },
  {
    icon: "Bell",
    title: "Identity-Linked Smart Reminders",
    description: "Never miss critical pet care with intelligent reminders tied to your pet's digital identity. Prevent expensive health issues, ensure optimal wellness, and save hundreds on emergency vet bills by staying on top of vaccinations, medications, and check-ups.",
    color: "bg-pet-blue",
    gradient: "from-sky-300 to-blue-400"
  },
  {
    icon: "Share2",
    title: "Instant Identity Sharing",
    description: "Share your pet's complete digital identity with veterinarians, pet sitters, or boarding facilities using their unique Pet SSN. No more frantic searches for documents or missed medical details - everything is instantly accessible and professionally presented.",
    color: "bg-pet-orange",
    gradient: "from-orange-300 to-amber-400"
  },
  {
    icon: "Globe",
    title: "Lifetime Portability",
    description: "Your pet's digital identity and Pet SSN travels with them anywhere in the world. Never lose access to critical information, regardless of location changes.",
    color: "bg-pet-pink",
    gradient: "from-pink-300 to-rose-400"
  },
  {
    icon: "Clock",
    title: "Smart Health Timeline",
    description: "Visualize your pet's complete health journey chronologically, all linked to their Pet SSN. Track patterns, milestones, and share comprehensive history with professionals.",
    color: "bg-pet-yellow",
    gradient: "from-amber-300 to-yellow-400"
  },
  {
    icon: "Users",
    title: "Multi-User Access Control",
    description: "Grant family members, pet sitters, or veterinarians controlled access to your pet's digital identity while maintaining full ownership and privacy control.",
    color: "bg-pet-green",
    gradient: "from-green-300 to-emerald-400"
  },
  {
    icon: "Smartphone",
    title: "Mobile Identity Access",
    description: "Access your pet's complete digital identity from any device, anywhere. Their Pet SSN ensures instant recognition and access to all linked information.",
    color: "bg-pet-purple",
    gradient: "from-indigo-300 to-violet-400"
  },
  {
    icon: "Zap",
    title: "Emergency ID Access",
    description: "In emergencies, veterinarians can instantly access your pet's critical information using their Pet SSN, enabling faster, more informed care decisions.",
    color: "bg-pet-orange",
    gradient: "from-amber-300 to-orange-400"
  },
  {
    icon: "Award",
    title: "Official Recognition",
    description: "Pet SSN provides official digital recognition that's increasingly accepted by veterinary clinics, pet services, and travel authorities worldwide.",
    color: "bg-pet-yellow",
    gradient: "from-yellow-300 to-amber-400"
  },
  {
    icon: "RefreshCw",
    title: "Lifetime Updates",
    description: "Your pet's digital identity grows with them. Add new records, update information, and maintain a complete lifelong profile all under one Pet SSN.",
    color: "bg-pet-pink",
    gradient: "from-rose-300 to-pink-400"
  }
];
